import { render, staticRenderFns } from "./tableLesson.vue?vue&type=template&id=5801f40a&"
import script from "./tableLesson.vue?vue&type=script&lang=js&"
export * from "./tableLesson.vue?vue&type=script&lang=js&"
import style0 from "./tableLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports